import { createStore, compose, combineReducers, applyMiddleware, AnyAction } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';
import fmTrees, { State as FMTreeState, TreeType } from './FMTree/FMTreeReducer';
import { Action, fetchTree } from './FMTree/FMTreeActions';
import fmImages, { State as FMImagesState } from './FMImages/FMImagesReducer';
import { Action as FMImagesAction, fetchGeopointIcons } from './FMImages/FMImagesActions';

let composeEnhancers = compose;

if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

export interface RootState {
    fmTrees: FMTreeState;
    fmImages: FMImagesState;
}

type RootAction = Action
    | FMImagesAction;



export default (fortMap) => {
    const store =  createStore(
        combineReducers<RootState, RootAction>({
            fmTrees,
            fmImages,
        }),
        composeEnhancers(
            applyMiddleware(thunk.withExtraArgument(fortMap))
        )
    );    
    (store.dispatch as ThunkDispatch<Promise<void>, {}, AnyAction>)(fetchGeopointIcons());
    
    window.addEventListener('fm:changeCompany', (event: any) => {
        (store.dispatch as ThunkDispatch<Promise<void>, {}, AnyAction>)(
            fetchTree(TreeType.geofencesTree, event.detail.currentCompany.companyId)
        );
    });

    return store
};
